import type { JSONSchemaType } from "ajv";

import { cameraSchema, gridSchema } from "./component-schemas";
import { entitySchema } from "./entity-schema";
import type { PanelConfig, PanelData } from "./types";

export const panelConfigSchema: JSONSchemaType<PanelConfig> = {
  type: "object",
  properties: {
    camera: { ...cameraSchema, nullable: true },
    grid: { ...gridSchema, nullable: true },
  },
  additionalProperties: false,
};

export const panelDataSchema: JSONSchemaType<PanelData> = {
  type: "object",
  properties: {
    entities: {
      type: "object",
      additionalProperties: entitySchema,
      minProperties: 1,
      required: [],
    },
  },
  required: ["entities"],
  additionalProperties: false,
};
